import styled from "styled-components";

export const Main = styled.section`
   display: flex;
   flex-direction: column;
   position: relative;
   width: 100%;
   height: 100vh;
   background-color: rgb(250, 250, 250);
   transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
   
   .contactUs {
      position: fixed;
      background: #d22d2d;
      color: #fff;
      opacity: 0;
      border-radius: 5px 0 0 5px;
      padding: 2px 15px;
      font-size: 15px;

      &.show {
         transition: all .3s ease-in-out;
         opacity: 1;
         bottom: 15px;
         right: 0;
         z-index: 999;
         box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
      }
      span:hover {
         text-decoration: underline;
         cursor: pointer;
      }
   }
   .chat-toggle-icon {
      position: fixed;
      bottom: 20px;
      right: 20px;
      height: 50px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 13px;
      cursor: pointer;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      z-index: 1000;
      padding: 0 30px;
      gap: 8px;
      
      svg {
         font-size: 18px;
      }
      span {
         margin-top: 3px;
         font-weight: 500;
         white-space: nowrap;
      }
      &:hover {
         transform: scale(1.05);
         box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
         background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
      }
      &:active {
         transform: scale(0.95);
      }
   }
   .logs {
      position: absolute;
      bottom: 15px;
      left: calc(15px + 26px + 15px);
      display: flex;

      > div {
         margin-right: 7.5px;
      }
      .boxLog {
         position: relative;
         display: flex;
         justify-content: center;
         align-items: center;
         margin-top: 7.5px;
         border-radius: 10px;
         background-color: #fff;
         box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
         padding: 0 15px;
         height: 52px;
         white-space: nowrap;
         z-index: 98;
         font-size: 15px;
         cursor: pointer;
         transition: all .2s ease-in-out;

         .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            background-image: linear-gradient(to right, #f97316, #ea580c);
            margin-right: 7.5px;
            border-radius: 10px;
            color: #fff;
         }
         .info {
            > span {
               font-size: 14px;
            }
            > div {
               font-size: 13px;
               margin-top: 3px;

               span:first-of-type {
                  margin-right: 7.5px;
               }
            }
         }
         &.processReport {
            .icon {
               background-image: linear-gradient(to right, #3b82f6, #2563eb);
            }
            .info > div span svg {
               margin-right: 4px;
            }
         }
         &.liveLog {
            .icon {
               background-image: linear-gradient(to right, #db5757, #d22d2d);
            }
         }
         /* span {
            opacity: 0.8;
         }
         svg {
            margin-left: 5px;
         }
         &:hover {
            opacity: 0.65;
         } */
      }
   }
   .react-flow {
      position: relative;
      display: flex;
      justify-content: center;
      
      .react-flow__controls .minimap svg {
         max-width: 15px;
         max-height: 15px;
      }
      .react-flow__minimap {
         box-shadow: 0 0 6px rgba(0,0,0,0.1), 0 0 6px rgba(0,0,0,0.1);
      }
      .react-flow__handle {
         width: 15px;
         height: 15px;
         background-color: rgb(250, 250, 250);
         border: 2px solid #8fa1b5;
         transition: all .2s ease-in-out;
         
         &:hover {
            width: 20px;
            height: 20px;
            border-color: #0099e6;
            background-color: rgb(0, 153, 230, 0.2);
         }
         &.hide {
            opacity: 0;
         }
         &.react-flow__handle-top {
            top: calc(-20px / 2);
         }
         &.react-flow__handle-bottom {
            bottom: calc(-20px / 2);
         }
         &.react-flow__handle-left {
            left: calc(-20px / 2);
         }
         &.react-flow__handle-right {
            right: calc(-20px / 2);
         }
         &.react-flow__handle-top .handleTitle {
            top: -25px;
         }
         &.react-flow__handle-bottom .handleTitle {
            bottom: -25px;
         }
         &.react-flow__handle-left .handleTitle {
            top: 5px;
            right: calc(100% + 5px);
         }
         &.react-flow__handle-right .handleTitle {
            top: 5px;
            left: calc(100% + 5px);
         }
         .handleTitle {
            position: absolute;
            font-size: 10px;
            white-space: nowrap;
            background-color: rgb(255, 255, 255);
            box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
            padding: 3px 5px;
            border-radius: 5px;
            z-index: -1;
         }
         &.handle-clickup {
            &.handle-child-Output-Lists {
               top: 20%;
            }
            &.handle-child-Full-Output {
               top: 40%;
            }
            &.handle-child-Output-Tasks {
               top: 60%;
            }
            &.handle-child-Output-Task-Link {
               top: 80%;
            }
            &.handle-child-Entity-Name {
               top: 25%;
            }
            &.handle-child-Headers {
               top: 52%;
            }
            &.handle-child-File {
               top: 80%;
            }
         }
         &.handle-routing {
            &.handle-child-Output-True {
               top: 35%;
            }
            &.handle-child-Output-False {
               top: 70%;
            }
         }
         &.handle-ocr {
            &.handle-child-Output-Full {
               top: 35%;
            }
            &.handle-child-Output-Processed-Files {
               top: 70%;
            }
         }
         &.handle-aiAgent {
            &.handle-child-Input {
               top: 50%;
            }
            &.handle-child-Tools {
               top: 72%;
            }
            &.handle-child-Output {
               top: 35%;
            }
         }
         &.handle-messengerSendMessage {
            &.handle-child-Listener {
               top: 35%;
            }
            &.handle-child-Ai-Content {
               top: 70%;
            }
         }
             &.handle-instaSendMessage {
            &.handle-child-Listener {
               top: 35%;
            }
            &.handle-child-Ai-Content {
               top: 70%;
            }
         }
         &.handle-odoo {
            &.handle-child-Name {
               top: 13%;
            }
            &.handle-child-Expected_Revenue {
               top: 23%;
            }
            &.handle-child-Probability {
               top: 33%;
            }
            &.handle-child-Customer {
               top: 43%;
            }
            &.handle-child-Email {
               top: 53%;
            }
            &.handle-child-Phone {
               top: 63%;
            }
            &.handle-child-Salesperson {
               top: 73%;
            }
            &.handle-child-Expected_Closing {
               top: 83%;
            }
            &.handle-child-Company_Name {
               top: 93%;
            }
            &.handle-child-Address {
               top: 17%;
            }
            &.handle-child-Contact_Name {
               top: 27%;
            }
            &.handle-child-Job_Position {
               top: 37%;
            }
            &.handle-child-Mobile {
               top: 47%;
            }
            &.handle-child-Website {
               top: 57%;
            }
            &.handle-child-Campaign {
               top: 67%;
            }
            &.handle-child-Medium {
               top: 77%;
            }
            &.handle-child-Sales_Team {
               top: 87%;
            }
         }
         &.handle-facebook {
            &.handle-child-Page-Id {
               top: 35%;
            }
            &.handle-child-Content {
               top: 70%;
            }
         }
         &.handle-leadsScorer {
            &.handle-child-Row-Data {
               top: 35%;
            }
            &.handle-child-Criteria {
               top: 70%;
            }
         }
         &.handle-realEstate {
            &.handle-child-Property {
               top: 25%;
            }
            &.handle-child-Location {
               top: 45%;
            }
            &.handle-child-City {
               top: 65%;
            }
            &.handle-child-Size {
               top: 85%;
            }
         }
         &.handle-openai {
            &.handle-child-Instructions {
               top: 35%;
            }
            &.handle-child-Input {
               top: 60%;
            }
         }
         &.handle-docSearch {
            &.handle-child-Input {
               top: 35% !important;
            }
            &.handle-child-File {
               top: 70%;
            }
         }
         &.handle-urlSearch {
            &.handle-child-Input {
               top: 25%;
            }
            &.handle-Website-URL {
               top: 50%;
            }
            &.handle-child-File {
               top: 75%;
            }
         }
         &.handle-googleGemini {
            &.handle-child-Input {
               top: 35%;
            }
            &.handle-child-File {
               top: 60%;
            }
         }
         &.handle-webhook {
            &.handle-child-Full-Output {
               top: 12.857%;
            }
            &.handle-child-Extractor-1 {
               top: 29.714%;
            }
            &.handle-child-Extractor-2 {
               top: 46.571%;
            }
            &.handle-child-Extractor-3 {
               top: 64.428%;
            }
            &.handle-child-Extractor-4 {
               top: 82.285%;
            }
            &.handle-child-Extractor-5 {
               top: 79.142%;
            }
            /*&.handle-child-Extractor-7 {
               top: 89.999%;
            } */
         }
         &.handle-sequencer {
            &.handle-child-RAG-Connection {
               top: 25%;
            }
            &.handle-child-ChatId {
               top: 50%;
            }
            &.handle-child-Input {
               top: 75%;
            }
            &.handle-child-Output-Message {
               left: 15%;
            }
            &.handle-child-Output-Full {
               left: 45%;
            }
            &.handle-child-Output-Summary {
               left: 75%;
            }
         }
         &.handle-spreadsheet {
            &.handle-child-Input {
               top: 35%;
            }
            &.handle-child-Spreadsheet-Id {
               top: 70%;
            }
            
         }
         &.handle-chatAgent {
            &.handle-child-Knowledge-Bases {
               top: 25%;
            }
            &.handle-child-ChatId {
               top: 50%;
            }
            &.handle-child-Message {
               top: 75%;
            }
            /* &.handle-child-Output-Profile {
               left: 30%;
            }
            &.handle-child-Output {
               left: 65%;
            } */
         }
         &.handle-chatAgent {
            &.handle-child-Output {
               top: 35%;
            }
            &.handle-child-Output-Message {
               top: 65%;
            }
         }
      }
   }
`;